module.exports = __webpack_public_path__ + "img/145.27a37bc0.jpg";